import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject } from '@angular/core';
import { ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatOption, MatSelect } from '@angular/material/select';

import { DynamicFormField, FormErrorPipe, SelectOption } from '@teamfoster/dynamic-forms';
import { FromDictionaryPipe } from '@teamfoster/sdk/dictionary-ngrx';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { Subject } from 'rxjs';

interface SearchSelectOption extends SelectOption {
  title: string;
  id: string;
  synonyms?: string[];
}

@Component({
  selector: 'app-form-select-search',
  imports: [
    NgClass,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatError,
    FormErrorPipe,
    MatSelect,
    MatOption,
    NgxMatSelectSearchModule,
    FromDictionaryPipe,
  ],
  templateUrl: './form-select-search.component.html',
  styleUrl: './form-select-search.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormSelectSearchComponent {
  config!: DynamicFormField;
  group!: UntypedFormGroup;
  private _unsubscribe = new Subject<void>();
  cd = inject(ChangeDetectorRef);

  filteredOptions(q: string) {
    if (!q || !this.config.selectOptions) {
      return this.config.selectOptions;
    }

    const options: SearchSelectOption[] = this.config.selectOptions!;

    return options?.filter(
      a =>
        this.normalizeQuery(a.title).includes(this.normalizeQuery(q)) ||
        a.synonyms?.flat()?.some(syn => this.normalizeQuery(syn)?.includes(this.normalizeQuery(q)))
    );
  }

  normalizeQuery(q: string): string {
    // also keep into account o should match ö
    return q
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();
  }
}
